module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-114x114.9fc249a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-114x114.png
// module id = 411
// module chunks = 1